import us from '../../../defines';

// This service allows regions to be copied and moved. Note that it operates in the context of a region, so it should
// probably be part of or extend the region class.

// Currently it's used by "Keyboard handler" and "region toolbar"

export class RegionInteraction {
  constructor (uScope, serviceLocator) {
    // HACK: Attach these items to uScope, since that's how the rest of the code works with it. It's really backwards
    //       and hard to follow because of this. TODO: integrate directly into the region object.
    let isCopyingRegion = false;

    uScope.isRegionCopyActive = function () {
      return isCopyingRegion;
    };

    uScope.startCopyMoveRegion = function (e, action) {
      isCopyingRegion = true;

      const {activeViewport, annotationsService} = serviceLocator;

      const regionToCopy = annotationsService.getSelRegion();

      // Validate we have a region to copy, and that we're not attempting to copy a report region
      if (!regionToCopy || (regionToCopy.isReportRegion && action === 'copy')) {
        return false;
      }

      regionToCopy.isCopyMoving = true;

      // show special highlight for copy/move region
      annotationsService.regHighLight(regionToCopy, true);

      if (action === 'copy') {
        let crsrPosBase;
        if (e.pageX) {
          // compute the position of the cursor in base image coords
          crsrPosBase = us.coordBaseImage(e, activeViewport);
        } else {
          crsrPosBase = regionToCopy.getCenter();
          crsrPosBase.add(10, 10);
        }
        annotationsService.regCopyTo(crsrPosBase, regionToCopy);
      }
      return true;
    };

    uScope.stopCopyMoveRegion = function () {
      const {annotationsService} = serviceLocator;
      const selectedRegion = annotationsService.getSelRegion();

      if (!selectedRegion) {
        return false;
      }

      isCopyingRegion = false; // TODO: Placing this after a validation failure smells like a logic bug
      selectedRegion.isCopyMoving = false;

      // return highlight to normal region select
      annotationsService.regHighLight(selectedRegion, true);

      // update the database with the region geometry change
      if (uScope.canSaveAnnotations()) {
        var regionXML = '<Region Id="' + selectedRegion.regionId + '">';
        var vertexXML = selectedRegion.buildVertexXML();
        regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';

        annotationsService.save({
          action: 'updateRegion',
          layerId: selectedRegion.layerId,
          regionXML
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/regions/region-interaction.js